import { Box, Typography, styled } from "@mui/material"
import type React from "react"
import { extraColors } from "../../utils/theme"
import type { NwssDetectionHeatmapTooltipProps } from "./NwssDetectionHeatmapTooltip"
import { getNwssHeatmapCellDetections } from "./useNwssSignalSamples"

const TooltipBody = styled(Box)(() => ({
  padding: 12,
  maxWidth: 280,
  maxHeight: 280,
  overflowY: "auto",
}))

const TooltipHeader = styled(Typography)(() => ({
  fontWeight: 800,
  color: extraColors.translucent50,
  marginBottom: 8,
  display: "block",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  fontSize: "0.65rem",
}))

const TooltipSubheader = styled(Typography)(() => ({
  fontWeight: 700,
  color: extraColors.white,
  marginBottom: 8,
  display: "block",
  fontSize: "0.75rem",
}))

/** Compact week tooltip for the site bubble timeline (no PCR target or event-member rows). */
export const NwssBubbleWeekTooltip: React.FC<
  NwssDetectionHeatmapTooltipProps & { inEventWindow?: boolean }
> = ({
  row,
  weekKey,
  weekLabel,
  samples,
  reportingCounties = null,
  lookbackMonths,
  inEventWindow = false,
}) => {
  const detections = getNwssHeatmapCellDetections(
    samples,
    row,
    weekKey,
    "site",
    reportingCounties,
    lookbackMonths
  )

  return (
    <TooltipBody>
      <TooltipHeader>Week of {weekLabel}</TooltipHeader>
      <TooltipSubheader>Site {row}</TooltipSubheader>
      {inEventWindow && (
        <Typography
          variant="caption"
          sx={{
            color: extraColors.translucent50,
            display: "block",
            mb: 0.75,
          }}
        >
          Within event window
        </Typography>
      )}
      <Typography
        variant="caption"
        sx={{
          color:
            detections.length > 0
              ? extraColors.status.redLight
              : extraColors.translucent50,
          display: "block",
          fontWeight: detections.length > 0 ? 700 : 400,
        }}
      >
        {detections.length === 0
          ? "No detections this week"
          : `${detections.length} detection${detections.length === 1 ? "" : "s"} this week`}
      </Typography>
    </TooltipBody>
  )
}
